module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["fr","en","nl"],"defaultLanguage":"fr","generateDefaultLanguagePage":true,"siteUrl":"https://exalto.be","i18nextOptions":{"interpolation":{"escapeValue":false},"nsSeparator":":"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleAnalytics":{"trackingId":"","anonymize":true},"facebookPixel":{"pixelId":""}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
